import { render, staticRenderFns } from "./TimestampAgo.vue?vue&type=template&id=3e567edc&scoped=true&"
import script from "./TimestampAgo.vue?vue&type=script&lang=ts&"
export * from "./TimestampAgo.vue?vue&type=script&lang=ts&"
import style0 from "./TimestampAgo.vue?vue&type=style&index=0&id=3e567edc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e567edc",
  null
  
)

export default component.exports